class LqdButtonHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initModal();
    this.initLocalScroll();
    this.initSplitText();

  }

  getDefaultSettings() {
    return {
      selectors: {
        modalTrigger: '[data-lqd-lity]',
        localScrollElement: '[data-localscroll]',
        splitTextElement: '[data-split-text]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $modalTrigger: this.$element.find(selectors.modalTrigger),
      $localScrollElement: this.$element.find(selectors.localScrollElement),
      $splitTextElement: this.$element.find(selectors.splitTextElement),
    }
  }

  initModal() {

    this.elements.$modalTrigger.liquidLightBox();

  }

  initLocalScroll() {

    this.elements.$localScrollElement.liquidLocalScroll();

  }

  initSplitText() {

    this.elements.$splitTextElement.liquidSplitText();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();
    this.handleModalDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }

  handleModalDestroy() {

    if ( ! this.elements.$modalTrigger.length ) return;

    const modalData = this.elements.$modalTrigger.data('plugin_liquidLightBox');
    
    if ( modalData ) {
      modalData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdButtonHandler, { $element } );
};